import Typography from "@mui/material/Typography";
import { TypographyStepTitle, TypographyNomalBold } from '../style/typography';
import CommonCard from '../components/common_card';
import Grid from "@mui/material/Grid2";
import { Box } from "@mui/system";
import { formatJSTDate } from "../func/util";

const EarthquakeInfo = ({ earthquake }) => {
    return (
        <>
            <Grid container size={{ xs: 12 }}>
                <Grid size={{ xs: 12, md: 9 }}>
                    <TypographyStepTitle sx={{ fontSize: { xs: "1.4rem", sm: "1.5rem", md: "1.5rem" } }}>地震概要</TypographyStepTitle>
                </Grid>
                <Grid
                    size={{ xs: 12, md: 3 }}
                    display="flex"
                    justifyContent="flex-end"
                >
                </Grid>
            </Grid>
            <Grid sx={{ mt: 1 }}>
                <CommonCard
                    sx={{ mt: 5 }}
                    child={
                        <Box sx={{ boxSizing: 'border-box' }}>
                            <Grid container spacing={5} columns={12} p={2}>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <TypographyNomalBold>
                                        地震発生日時
                                    </TypographyNomalBold>
                                    <Typography>{formatJSTDate(earthquake.occured_at) ?? '-'}</Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <TypographyNomalBold>
                                        最大震度
                                    </TypographyNomalBold>
                                    <Typography>
                                        {earthquake?.max_intensity != null
                                            ? `震度${earthquake.max_intensity}`
                                            : '-'}
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <TypographyNomalBold>
                                        震源地
                                    </TypographyNomalBold>
                                    <Typography>{earthquake.epicenter ?? '-'}</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    }
                />
            </Grid>
        </>
    );
};

export default EarthquakeInfo;